<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="input" label="代理商手机号" name="agency_user_manage_mobilephone"></c-form-item>
					<c-form-item type="input" label="代理商昵称" name="agency_user_nick_name" placeholder="模糊匹配"></c-form-item>
					<c-form-item type="input" label="采购人手机号" name="order_user_manage_mobilephone"></c-form-item>
					<c-form-item type="input" label="采购人昵称" name="order_user_nick_name" placeholder="模糊匹配"></c-form-item>
					<c-form-item type="checkbox" label="订单类型" name="order_type" :options="orderType"></c-form-item>
<!--					<c-form-item type="checkbox" label="销售方式" name="order_classify" :options="orderClassify"></c-form-item>-->
					<c-form-item type="input" label="商品名称" name="product_name" placeholder="模糊匹配"></c-form-item>
					<c-form-item type="input" label="收货人" name="receiving_name"></c-form-item>
					<c-form-item type="input" label="收货人电话" name="receiving_phone"></c-form-item>
                    <c-form-item type="input" label="交付门店" name="service_center" placeholder="模糊匹配,支持门店名称、联系人信息搜索"></c-form-item>
					<c-form-item type="datetime" label="下单时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="datetime" label="付款时间" start-name="pay_start_date" end-name="pay_end_date"></c-form-item>
					<c-form-item type="checkbox" label="订单状态" name="order_state" :options="orderState"></c-form-item>
				</c-form>
			</m-search>
			<m-operate>
				<c-button power="b_sub_order_export" @click="exportData()" icon="export">导出订单列表明细</c-button>
			</m-operate>
			<c-table ref="table">
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="订单号"
					name="sub_order_number"
					width="120"
				>
					<template v-slot="{data}">
						<a class="s-link" style="text-decoration: underline;" @click="navigateTo(`/order_detail/${data.sub_order_number}`)">{{data.sub_order_number}}</a>
					</template>
				</c-table-column>
				
<!--				<c-table-column-->
<!--					label="销售方式"-->
<!--					name="order_classify"-->
<!--					width="80"-->
<!--				>-->
<!--					<template v-slot="{data}">-->
<!--						<span v-if="data.order_classify==1" style="color:green">{{orderClassifyName[data.order_classify]}}</span>-->
<!--						<span v-if="data.order_classify==2" style="color:#0000ff">{{orderClassifyName[data.order_classify]}}</span>-->
<!--						<span v-if="data.order_classify==1 && data.order_number == data.sub_order_number" style="color:#999">(原单)</span>-->
<!--					</template>-->
<!--				</c-table-column>-->
				
				<c-table-column
					label="订单来源"
					name="order_source"
					width="80"
				>
					<template v-slot="{data}">
						{{orderSourceName[data.order_source]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="订单状态"
					name="order_state"
					width="90"
				>
					<template v-slot="{data}">
						<span v-if="data.order_state == 6" style="color:#999">{{orderStateName[data.order_state]}}</span>
						<span v-else-if="data.check_state==1 || data.check_state==3" style="color:#182eff">{{orderStateName[data.order_state]}}</span>
						<span v-else-if="data.check_state==2"> 
							<span v-if="data.refund_flag == 1" style="color: #ff5555">退款中</span>
							<span v-else-if="data.return_flag == 1" style="color: #ff5555">退货中</span>
							<span v-else>
								<span v-if="data.payment_state == 2" style="color:#708fff">待付尾款</span>
								<span v-else>
									<span v-if="data.order_state == 1" style="color:#182eff">{{orderStateName[data.order_state]}}</span>
									<span v-if="data.order_state == 2" style="color:#182eff">{{orderStateName[data.order_state]}}</span>
									<span v-if="data.order_state == 3" style="color:#69d39c">{{orderStateName[data.order_state]}}</span>
									<span v-if="data.order_state == 5" style="color:darkgreen">{{orderStateName[data.order_state]}}</span>
								</span>
							</span>
							<span v-if="data.order_state==3 && data.deliver_state=='部分发货'"><br/> (<span style="color:dodgerblue">{{ data.deliver_state}}</span>)</span>
						</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="开票状态"
					name="invoice_state"
					width="110"
					v-if="systemConfig.order_invoice_enabled == 'ON'" 
				>
					<template v-slot="{data}">
						<span v-if="data.order_state == 3 || data.order_state == 5">
							<span style="color:#bbbbbb" v-if="data.invoice_count > 0 && data.invoice_state==1 && data.exp_date_count < 10">{{invoiceStateName[data.invoice_state]}}(10天内)</span>
							<span style="color:#00aaff" v-if="data.invoice_count > 0 && data.invoice_state==1 && data.exp_date_count >= 10 && data.exp_date_count < 20">{{invoiceStateName[data.invoice_state]}}(超10天)</span>
							<span style="color:#e1e100" v-if="data.invoice_count > 0 && data.invoice_state==1 && data.exp_date_count >= 20 && data.exp_date_count < 30">{{invoiceStateName[data.invoice_state]}}(超20天)</span>
							<span style="color:red" v-if="data.invoice_count > 0 && data.invoice_state==1 && data.exp_date_count >= 30">{{invoiceStateName[data.invoice_state]}}(超30天)</span>
							<span style="color:#79f3b4" v-if="data.invoice_count == 0 && data.invoice_state==1">{{invoiceStateName[0]}}</span>
							<span style="color:darkgreen" v-if="data.invoice_state==2">{{invoiceStateName[data.invoice_state]}}</span>
						</span>
						<span v-else style="color:#dddddd" >--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="代理商昵称"
					name="nick_name3"
					width="150"
				>
					<template v-slot="{data}">
						<span v-if="data.nick_name3">{{data.nick_name3}}</span>
						<span v-else style="color:#999">-</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="代理商手机号"
					name="user_manage_mobilephone3"
					width="110"
				>
					<template v-slot="{data}">
						<span v-if="data.user_manage_mobilephone3">{{data.user_manage_mobilephone3}}</span>
						<span v-else style="color:#999">-</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="采购人昵称"
					name="nick_name2"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="采购人手机号"
					name="user_manage_mobilephone2"
					width="110"
				>
				</c-table-column>
				
				<c-table-column
					label="下单时间"
					name="create_date"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="购买数量"
					name="product_count"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="订单金额"
					name="sub_product_money"
					width="130"
				>
				<template v-slot="{data}">
					<span v-if="data.order_type==2" style="color:#888888">
						{{data.product_money}}（积分）
					</span>
					<span v-if="data.order_type==2 && data.logistics_money > 0" style="color:orangered">
						(另运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
					</span>
					<span v-if="data.order_type!=2 && data.payment_state != 3" style="color:#888888">
						￥{{parseFloat(data.sub_product_money).toFixed(2)}}
					</span>
					<span v-if="data.order_type!=2 && data.payment_state == 3" style="color:darkgreen">
						￥{{parseFloat(data.sub_product_money).toFixed(2)}}
					</span>
					<span v-if="data.order_type!=2 && data.logistics_money > 0" style="color:orangered">
						(运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
					</span>
					<span v-if="data.order_type!=2 && data.total_fee_money > 0" style="color:orangered">
						<br/>(含服务费￥{{parseFloat(data.total_fee_money).toFixed(2)}})
					</span>
					<span v-if="data.order_type==7 && data.custom_money > 0" style="color:orangered">
						<br/>(含定制费￥{{parseFloat(data.custom_money).toFixed(2)}})
					</span>
				</template>
				</c-table-column>
				
				<c-table-column
					label="收货人"
					name="receiving_name"
					width="110"
				></c-table-column>
				
				<c-table-column
					label="收货人电话"
					name="receiving_phone"
					width="120"
				></c-table-column>

				
				<c-table-column
					label="配送方式"
					name="logistics_company_name"
					width="90"
				></c-table-column>

                <c-table-column
                        label="交付门店"
                        name="service_center"
                        width="250"
                >
                    <template v-slot="{data}">
                        <span v-if="data.order_number == data.sub_order_number">
                            {{data.service_center}}
                        </span>
                        <span v-else style="color:#bbbbbb" >--</span>
                    </template>
                </c-table-column>
				
				<c-table-column
					label="备注"
					name="order_remark"
					width="110"
				>
					<template v-slot="{data}">
						<span v-if="data.order_remark">
							{{data.order_remark}}
						</span>
						<span v-else style="color:#bbbbbb" >--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="终端订单号"
					name="order_number"
					width="120"
				>
				</c-table-column>
				
				<c-table-column
					label="发货时间"
					name="send_dates"
					width="150"
				>
					<template v-slot="{data}">
						<span v-if="data.send_dates">
							{{data.send_dates}}
						</span>
						<span v-else style="color:#bbbbbb" >--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="70"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/order_detail/${data.sub_order_number}`)">查看</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		name: 'm_sub_order',

		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
		},

        props: {
            check_state: String,
            order_state: String,
            invoice_state: String,
            pay_state: String,
            reconciliation_state: String
        },

        data() {
			return {
                is_bath:0,
                text_msg:'',
                realityMoney: 0,
				invoiceDate:'',	//开票时间
				cancel_reason:'', //关闭原因
                invoice_file_type:'',//开票文件类型
                invoice_file:'',//发票文件
				orderStateName: {
					1: '待付款',
					2: '待发货',
					3: '待收货',
					5: '交易完结',
					6: '已关闭'
				},
				orderModeName: {
					1: '平台自营',
					2: '商家自营'
				},
				orderTypeName: {
					1: '普通',
					2: '积分',
					3: '赠品',
					4: '砍价',
					5: '预定全款',
					6: '预定定金',
                    7: '定制',
                    18: '搭配购',
                    19: '一元购',
                    99: '微信小店'
				},
				orderClassifyName: {
					1: '供货',
					2: '直销'
				},
				orderSourceName: {
					'OMS':'管理后台',
					'IOS': '苹果',
					'ANDROID': '安卓',
					'MINI': '小程序',
					'PC': 'PC电脑'
				},
				freightPaymentTypeName:{
					1: '运费先付',
					2: '运费到付'
				},
				orderState: [{
						name: '待付款',
						value: 1
					},{
						name: '待发货',
						value: 2
					},{
						name: '待收货',
						value: 3
					},{
						name: '交易完结',
						value: 5
					},{
						name: '已关闭',
						value: 6
					}
				],
				checkState: [{
						name: '待审核',
						value: 1
					},{
						name: '审核通过',
						value: 2
					},{
						name: '审核不通过',
						value: 3
					}
				],
				invoiceStateName: {
					0: '无需开票',
					1: '未开票',
					2: '已开票'
				},
				pushState: [{
						name: '无需推送',
						value: 0
					},{
						name: '待推送',
						value: 1
					},{
						name: '已推送',
						value: 3
					}
				],
				operationMode: [{
						name: '平台自营',
						value: 1
					},{
						name: '商家运营',
						value: 2
					}
				],
				invoiceState:[{
						name: '无需开票',
						value: 0
					},{
						name: '未开票',
						value: 1
					},{
						name: '已开票',
						value: 2
					}
				],
                invoiceFileType:[{
                    name: '附件',
                    value: 1
                },{
                    name: '链接',
                    value: 2
                }]
			}
		},

        computed: {
			...mapState(['systemConfig']),
			orderClassify(){
				return ([{
					name:'供货',
					value: 1
				},{
					name:'直销',
					value: 2
				}]);
			},
			orderType() {
				return (
					[{
					  name: '商城自销',
					  value: 1,
					},{
						name: '微信小店',
						value: 99
					// },{
					//   name: '赠品',
					//   value: 3
					}].concat(this.systemConfig.points_system == 'ON'?[{
						name: '积分',
						value: 2
					}]:[])
					.concat(this.systemConfig.bargain_enabled == 'ON'?[{
						name: '砍价',
						value: 4
					}]:[])
					.concat(this.systemConfig.presell_enabled == 'ON'?[{
						name: '预定全款',
						value: 5
					}]:[])
					.concat(this.systemConfig.presell_enabled == 'ON'?[{
						name: '预定定金',
						value: 6
					}]:[])
					.concat(this.systemConfig.product_custom == 'ON'?[{
						name: '定制',
						value: 7
					}]:[])
				);
			},
			
            defaultSearch() {
                let param = {
                    check_state: this.check_state ? this.check_state.split(',') : [],
                    order_state: this.order_state ? this.order_state.split(',') : [],
                    invoice_state: this.invoice_state ? this.invoice_state.split(',') : [],
                    reconciliation_state: this.reconciliation_state? this.reconciliation_state.split(',') : [],
                }

                if (this.pay_state == 1) {
                    param.pay_start_date = new Date().format('yyyy-MM-dd') + ' 00:00:00';
                    param.pay_end_date = new Date().format('yyyy-MM-dd') + ' 23:59:59';
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

        mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
            this.$bus.$on('order.update', data => {
                // 刷新列表
                this.$refs.table.update();
            });
        },


		methods: {
			//搜索
			searchHandle(data) {
				data.stationed_type = 1;
				this.searchDate = data;
				this.$refs.table.load({
					url: '/order/sub_list',
					data
				});
			},
			//批量导出订单
			exportData() {
				var data = this.searchDate;
				data.job_id = 39;
				data.order_numbers = Array.from(this.$refs.table.getRow('selected'), item => item.data.order_number);
				this.request({
					url: '/export_job/add',
					data: data,
					loading: true,
					success: data => {
						this.$message({
							text: '订单导出任务提交成功，请稍后前往任务中心查看',
							icon: 'success'
						});
					}
				});
				
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			}
		}
	}
</script>
<style lang="stylus" scoped>	
	.order {
		&-verify {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 120px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}
	
	.invoice {
		padding: 5px 10px;
		box-sizing: border-box;
		
		p {
			font-weight: bold;
			margin-bottom: 30px;
			font-size: 15px;
		}
	}
</style>